import "./_button.scss";

import cx from "classnames";
import {MouseEvent} from "react";

const buttonVariant = (variant: string): object => {
  return {
    "button-component--primary": variant.includes("primary"),
    "button-component--secondary": variant.includes("secondary"),
    "button-component--tertiary": variant.includes("tertiary"),
    "button-component--validate": variant.includes("validate"),
    "button-component--negate": variant.includes("negate"),
    "button-component--onlyIcon": variant.includes("icon"),
    "button-component--circle": variant.includes("circle"),
    "button-component--disable": variant.includes("disable"),
  };
};

function Button({
  label,
  onClick,
  variant = "primary",
  type = "button",
  icon = undefined,
  className = "",
  disabled = false,
}: {
  label: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  variant?: string;
  type?: "submit" | "button" | "reset";
  icon?: string;
  className?: string;
  disabled?: boolean;
}): JSX.Element {
  const handleClick = (
    event: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>,
  ): void => {
    onClick(event);
  };
  return (
    <button
      className={cx("button-component", buttonVariant(variant), className)}
      onClick={type !== "submit" ? handleClick : undefined}
      type={type}
      disabled={disabled}>
      {icon !== undefined || null ? (
        <img src={icon} alt={`icon button ${label}`} loading="lazy" />
      ) : null}
      {label}
    </button>
  );
}

export default Button;
